import { toast } from "@zerodevx/svelte-toast";

export const errorToast500 = () => {
    toast.push(
        "Something went wrong ☹️  We're looking into it.",
        {
            theme: {
                "--toastBackground": "#123456",
                "--toastProgressBackground": "#123456",
                "--toastWidth": "600px",
            },
            duration: 3000,
        }
    )
}

export const successToast = (message) => {
    toast.push(
        message,
        {
            theme: {
                "--toastBackground": "#48BB78",
                "--toastProgressBackground": "#2F855A",
                "--toastWidth": "600px",
            },
            duration: 3000,
        }
    );
}